module.exports = __webpack_public_path__ + "static/img/053.84e47bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/053.png
// module id = Ryld
// module chunks = 0